import axios from "axios";
import {hasRole} from "@/functions/authentication-functions";
import {SettingsContext} from "@/utilities/settings-context";

const canRequest = () => hasRole("Administrator") || hasRole("Moderator");

export const updateCompanyIncludedPackages = async (companyId: number, packageIds: number[], volumePackageIsLight?: boolean) => {
    if (!canRequest()) {
        return;
    }

    await axios.post(SettingsContext.getApiUrl('updateCompanyIncludedPackages'), {
        id: companyId, 
        packageIds, 
        volumePackageIsLight
    });
};